import React, { useEffect, useState } from "react";
import axios from "axios";
import "./rolling.css";

const API_BASE = "https://login.abhedasramam.org//myapp/api/uploads";

function Rolling() {
  const [uploads, setUploads] = useState([]);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    const res = await axios.get(`${API_BASE}/get_notice.php`);
    setUploads(res.data || []);
  };

  return (
    <div className="rolling-container">
      {/* <h4 className="rolling-title">Latest Updates</h4> */}

      <div className="rolling-wrapper">
        <div className="rolling-content">
          {uploads.map((row, i) => (
            <div
              key={row.id || i}
              className={`rolling-item ${
                row.file_path ? "clickable" : "disabled"
              }`}
              onClick={() => {
                if (!row.file_path) return;
                window.open(`myapp/${row.file_path}`, "_blank");
              }}
            >
              <span className="icon">👉</span>
              <span className="text">{row.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Rolling;
